module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-ffc53a9182d7c5472e2349ff9dd78577.png";